import React, { createContext, useContext } from 'react';

const CustomerResourceContext = createContext(undefined);

export const CustomerResourceProvider = ({ children, value }) => {
    return <CustomerResourceContext.Provider value={value}>{children}</CustomerResourceContext.Provider>;
};

export const useCustomerResourceContext = () => {
    const context = useContext(CustomerResourceContext);
    if (context === undefined) {
        throw new Error('useCustomerResourceContext 必須在 CustomerResourceProvider 中使用');
    }
    return context; 
};
